// extracted by mini-css-extract-plugin
module.exports = {"container":"sign-up-form_container__35WYR","loading":"sign-up-form_loading__3LKGB","wrapper":"sign-up-form_wrapper__3M_UV"};